// /**
//  * Parcel - Add
//  */

// React
import React, { useEffect, useState } from 'react';

// react hook form
import { useForm } from 'react-hook-form';

// UI
import {
    TextField,
    Grid,
    Button,
    Paper,
    Typography,
    DialogContent,
    DialogActions,
    Dialog,
    Divider,
    InputAdornment,
    IconButton,
} from '@material-ui/core';

import classes from './add.module.scss';
import tokenRepository from 'client-sdk/src/Repository/token-repository';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import RonadIcons from '../../components/iconComponent';

type Props = {
    create: (body: any) => void;
    onClose: () => void;
    warehouseId: number;
    createParcelsDispatch: (payload: any) => void;
};

type Inputs = {
    basalamUrl: string;
    userName: string;
    password: string;
    shopID: string;
    token: string
};

const partnerId = localStorage.getItem("partnerId")

function TokenManagement(props: Props) {
    const { search } = useLocation()
    const history = useHistory();
    const { register, handleSubmit, watch, setValue, getValues } = useForm<Inputs>({
        defaultValues: {
            userName: "",
            password: "",
            shopID: "",
            token: ""
        },
    });
    const [tab, setTab] = useState(1)
    const [shopInfo, setShopInfo] = useState({})
    const [shopType, setShopType] = useState("")
    const [token, setToken] = useState(null)
    const [modal, setModal] = useState("")
    const [basalamUrl, setBasalamUrl] = useState("")
    const [copied, setCopied] = useState<boolean>(false);
    const [hide, setHide] = useState(true);
    const [externalToken, setExternalToken] = useState(null)
    const code = queryString.parse(search).code
    const state = queryString.parse(search).state

    useEffect(() => {
        showToken()
        getExternalTokens()
        if (code) {
            basalamTokenRegister()
        } else {
            getPartnerBasalamToken()
        }
    }, [])

    const showToken = async () => {
        try {
            const {response} = await tokenRepository.showToken({payload: {
                id: partnerId,
                emailAddress: getValues().userName || "",
                password: getValues().password || "",
                rememberMe:true
            }})
            setToken(response.data.token)
            setModal("")
        } catch (error) {
            handleError(error)
        }
    }

    const createToken = async () => {
        try {
            const {response} = await tokenRepository.renewToken({payload: {
                id: partnerId,
                emailAddress: getValues().userName || "",
                password: getValues().password || "",
                rememberMe:true
            }})
            setToken(response.data.token)
            setModal("")
        } catch (error) {
            handleError(error)
        }
    }

    const onSubmit = (data: Inputs) => {

    };

    const submitBasalamShop = (redirectUrl: string) => {
        window.location.replace(redirectUrl)
    }

    const getPartnerBasalamToken = async () => {
        try {
            const response = await tokenRepository.getShopInfo()
            setShopInfo(response.data)
            response?.data?.basalamPartnerInfo?.basalamPartnerUrl && setBasalamUrl(response?.data?.basalamPartnerInfo?.basalamPartnerUrl)
        } catch (error) {
            handleError(error)
        }
    }

    const registerBasalamUrl = async () => {
        try {
            const response = await tokenRepository.RegisterShopUrl({ payload: { basalamPartnerUrl: basalamUrl} })
            setShopInfo(response.data)
            handleNotfication("آدرس غرفه شما ذخیره شد لطفا مراحل احراز هویت را انجام دهید.", "success")
        } catch (error) {
            handleError(error)
        }
    }

    const buttonFunctionBuilder = () => {
        if (shopInfo?.basalamPartnerInfo?.basalamPartnerUrl) {
            return initBasalamOAuth
        }
        return registerBasalamUrl
    }


    const initBasalamOAuth = async () => {
        const UUID = generateUUID()
        try {
            const response = await tokenRepository.InitializeBasalamOAuth({payload: {id: UUID}})
            localStorage.setItem("generatedCode", UUID)
            submitBasalamShop(response.data)
        } catch (error) {
            handleError(error)
        }
    }

    const generateUUID = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
            .replace(/[xy]/g, function (c) {
                const r = Math.random() * 16 | 0, 
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
    }

    const buttonLabelBuilder = () => {
        if (shopInfo?.basalamPartnerInfo?.basalamPartnerUrl) {
            return "احراز هویت"
        }
        return "تایید"
    }

    const basalamTokenRegister = async () => {
        const generatedCode = localStorage.getItem("generatedCode")
        if(state === generatedCode) {
            try {
                const response = await tokenRepository.RegisterBasalamToken({ payload: { code } })
                setShopInfo(response.data)
                setBasalamUrl(response.data?.basalamPartnerInfo?.basalamPartnerUrl)
                handleNotfication("احراز هویت شما با موفقیت انجام شد.", "success")
                history.replace("/integration")
                localStorage.removeItem('generatedCode')
            } catch (error) {
                handleError(error)
            }
        }else {
            handleNotfication("کد باسلام شما معتبر نیست.", "error")
        }
    }

    const copyToken = () => {
        setCopied(true)
        navigator.clipboard.writeText(token)
        setTimeout(() => {
            setCopied(false)
        }, 3000)
    }

    const getExternalTokens = async () => {
        try {
            const {response} = await tokenRepository.getExternalTokens({payload: {id: partnerId}})
            setExternalToken(response.data)
        } catch (error) {
            handleError(error)
        }
    }

    const revokeToken = async () => {
        try {
            const {response} = await tokenRepository.revokeToken({payload: {
                id: partnerId,
            }})
            console.log(response)
            handleNotfication("توکن شما با موفقیت حذف شد.", "success")
            setToken(null)
            setModal("")
        } catch (error) {
            handleError(error)
        }
    }

    const openExternalModal = (shopId: string) => {
        setModal("CREATE_EXTERNAL_TOKEN")
        setShopType(shopId)
    }

    const createExternalToken = async () => {
        try {
            const {response} = await tokenRepository.registerExternalToken({payload: {
                id: partnerId,
                shopId: getValues().shopID,
                token: getValues().token,
                type: shopType
            }})
            setValue("shopID", "")
            setValue("token", "")
            setModal("")
            getExternalTokens()
            handleNotfication("توکن با موفقیت ثبت شد.", "success")
        } catch (error) {
            handleError(error)
        }
    }

    return (
        <>
            <Typography variant="h6" component="h2">
                توکن‌ها
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={classes.formWrapper}>
                    <ul className={classes.tabContainer}>
                        <li onClick={() => setTab(1)} className={classes.tabItems + " " + (tab == 1 && classes.active)}>دریافت توکن</li>
                        <li onClick={() => setTab(2)} className={classes.tabItems + " " + (tab == 2 && classes.active)}>افزودن توکن</li>
                    </ul>
                    {tab == 1 && <Grid container alignItems='stretch' style={{ marginTop: "70px" }}>
                        {token ?<>
                            <Grid item style={{marginLeft: "12px"}}>
                                <Button
                                    type="submit"
                                    size="large"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    style={{ borderRadius: "4px", height: "100%" }}
                                    onClick={() => setModal("CREATE_TOKEN")}
                                    endIcon={<RonadIcons name='plus' size={.6} className='text-white'/>}
                                >دریافت مجدد توکن</Button>
                            </Grid>
                            <Grid item style={{marginLeft: "12px"}}>
                                <Button
                                    type="submit"
                                    size="large"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    style={{ borderRadius: "4px", height: "100%" }}
                                    onClick={() => setModal("SHOW_TOKEN")}
                                    endIcon={
                                        <RonadIcons name="eye" size={1} className='text-white'/>
                                    }
                                >نمایش توکن</Button>
                            </Grid>
                            <Grid item style={{marginLeft: "12px"}}>
                                <Button
                                    type="submit"
                                    size="large"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    style={{ borderRadius: "4px", height: "100%" }}
                                    onClick={() => setModal("REVOKE_TOKEN")}
                                    endIcon={<RonadIcons name='trash' className='text-white' size={0.8}/>}
                                >حذف</Button>
                            </Grid>
                            <Grid item >
                                <div className={classes.tokenBox + (copied ? " " + classes.copied : "")}>
                                    <p>{copied ? "کپی شد." : token}</p>
                                    {copied ? <RonadIcons name='check' />  : <RonadIcons name='copy' title='رونوشت' onClick={copyToken}/>}
                                </div>
                            </Grid>
                        </> :<><Grid item lg={1}>
                            <Button
                                size="large"
                                variant="contained"
                                color="primary"
                                fullWidth
                                // disabled={!getValues().userName || !getValues().password}
                                style={{ borderRadius: "4px", height: "100%" }}
                                onClick={createToken}
                                endIcon={<RonadIcons name='plus' size={.6} className='text-white'/>}
                            >ایجاد توکن</Button>
                        </Grid>
                        <Grid item lg={2}>
                            <div style={{ display: "flex", width: "100%", paddingRight: "18px" }}>
                                <TextField
                                    fullWidth
                                    placeholder='نام کاربری'
                                    variant='outlined'
                                    id='userName'
                                    name='userName'
                                    inputRef={register({ required: true })}
                                />
                            </div>
                        </Grid>
                        <Grid item lg={2}>
                            <div style={{ display: "flex", width: "100%", paddingRight: "18px" }}>
                                <TextField
                                    fullWidth
                                    placeholder='رمز عبور'
                                    variant='outlined'
                                    id='password'
                                    type={hide ? 'password' : 'text'}
                                    name='password'
                                    inputRef={register({ required: true })}
                                    InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <IconButton onClick={() => setHide(!hide)}>
                                              <RonadIcons name={hide ? "eyeOff" : "eye"} className={classes.icon}/>
                                            </IconButton>
                                          </InputAdornment>
                                        ),
                                    }}
                                />
                            </div>
                        </Grid></>}
                    </Grid>}
                    {tab == 2 && <Grid container justifyContent='space-between' style={{ marginTop: "70px" }}>
                        <Grid item lg={12}>
                            <div style={{ display: "flex", alignItems: "center", width: "100%", marginLeft: "24px" }}>
                                <label htmlFor="basalamUrl" style={{ marginLeft: "3px", width: "150px" }}>نام غرفه با‌سلام</label>
                                <div style={{ display: "flex", width: "100%" }}>
                                    <div className='TextField-without-border-radius' style={{ width: "100%" }}>
                                        <TextField
                                            fullWidth
                                            dir='ltr'
                                            placeholder='example'
                                            variant='outlined'
                                            id='basalamUrl'
                                            name='basalamUrl'
                                            onChange={e => setBasalamUrl(e.target.value)}
                                            value={basalamUrl}
                                            disabled={shopInfo?.basalamPartnerInfo?.basalamPartnerUrl}
                                        />
                                    </div>
                                    <Button
                                        type="submit"
                                        size="large"
                                        variant="contained"
                                        color="primary"
                                        disabled={shopInfo?.basalamPartnerInfo?.registrationStatus === "AUTHENTICATED"}
                                        style={{ borderRadius: "4px 0 0 4px", width: "20%" }}
                                        onClick={buttonFunctionBuilder()}
                                    >{buttonLabelBuilder()}</Button>
                                </div>
                            </div>
                        </Grid>
                        <Grid item lg={12}>
                            <div style={{ display: "flex", alignItems: "center", marginTop: "24px" }}>
                                <label htmlFor="tapinKetabToken" style={{ marginLeft: "3px", width: "150px" }}>توکن دیجی‌کالا</label>
                                <div style={{ display: "flex", height: "50px",width: "100%", justifyContent: "space-between", backgroundColor: "#25368C0D", padding: "0 10px" ,border: "1px solid #25368CCC", borderRadius: "4px" }}>
                                    <p>{externalToken?.hasDigikalaToken ? "***********" : ""}</p>
                                    <RonadIcons name='pencil' title='ویرایش' onClick={() => openExternalModal("DIGIKALA")}/>
                                </div>
                            </div>
                        </Grid>
                        <Grid item lg={12}>
                            <div style={{ display: "flex", alignItems: "center", marginTop: "24px" }}>
                                <label htmlFor="tapinToken" style={{ marginLeft: "3px", width: "150px" }}>تاپین</label>
                                <div style={{ display: "flex", width: "100%", justifyContent: "space-between", backgroundColor: "#25368C0D", padding: "0 10px" ,border: "1px solid #25368CCC", borderRadius: "4px" }}>
                                    <p>توکن: {externalToken?.hasTapinToken ? "***********" : ""}</p>
                                    <p>شناسه فروشگاه: {externalToken?.hasTapinToken ? "***********" : ""}</p>
                                    <RonadIcons name='pencil' title='ویرایش' onClick={() => openExternalModal("TAPIN")}/>
                                </div>
                            </div>
                        </Grid>
                        <Grid item lg={12}>
                            <div style={{ display: "flex", alignItems: "center", marginTop: "24px" }}>
                                <label htmlFor="tapinToken" style={{ marginLeft: "3px", width: "150px" }}>تاپین کتاب</label>
                                <div style={{ display: "flex", width: "100%", justifyContent: "space-between", backgroundColor: "#25368C0D", padding: "0 10px" ,border: "1px solid #25368CCC", borderRadius: "4px" }}>
                                    <p>توکن: {externalToken?.hasTapinKetabToken ? "***********" : ""}</p>
                                    <p>شناسه فروشگاه: {externalToken?.hasTapinKetabToken ? "***********" : ""}</p>
                                    <RonadIcons name='pencil' title='ویرایش' onClick={() => openExternalModal("TAPIN_KETAB")}/>
                                </div>
                            </div>
                        </Grid>
                        {/* <Grid item lg={6}>
                            <div style={{ display: "flex", alignItems: "center", marginTop: "24px",marginRight: "24px" }}>
                                <label htmlFor="tapinKetabId" style={{ marginLeft: "16px", width: "150px" }}>شناسه فروشگاه</label>
                                <div style={{ display: "flex", width: "100%" }}>
                                    <TextField
                                        fullWidth
                                        dir='ltr'
                                        variant='outlined'
                                        id='tapinKetabId'
                                        name='tapinKetabId'
                                        inputRef={register({ required: true })}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <RonadIcons name='paste' title='جایگذاری' onClick={() => {
                                                        navigator.clipboard.readText().then(text => setValue("tapinKetabId", text))
                                                    }}/>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </div>
                            </div>
                        </Grid>
                        <Grid item lg={6}>
                            <div style={{ display: "flex", alignItems: "center", marginTop: "24px" }}>
                            <label htmlFor="digikalaToken" style={{ marginLeft: "16px", width: "150px" }}>توکن دیجیکالا</label>
                                <div style={{ display: "flex", width: "100%" }}>
                                    <TextField
                                        fullWidth
                                        dir='ltr'
                                        variant='outlined'
                                        id='digikalaToken'
                                        name='digikalaToken'
                                        inputRef={register({ required: true })}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <RonadIcons name='paste' title='جایگذاری' onClick={() => {
                                                        navigator.clipboard.readText().then(text => setValue("digikalaToken", text))
                                                    }}/>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </div>
                            </div>
                        </Grid> */}
                    </Grid>}
                </div>
                {/* <Grid
                    container
                    justifyContent='flex-end'
                >
                    <Button
                        type="submit"
                        size="medium"
                        data-cy="saveBtn"
                        variant="contained"
                        color="primary"
                    >
                        ویرایش
                    </Button>
                </Grid> */}
            </form>
            <Dialog
                open={modal === "CREATE_TOKEN"}
                fullWidth
                onClose={() => setModal("")}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <div
                        style={{
                            position: 'absolute',
                            left: '3px',
                            top: '10px',
                            zIndex: 10,
                        }}
                    >
                        <IconButton aria-label="close" onClick={() => setModal("")}>
                            <RonadIcons name="times" size={0.8} />
                        </IconButton>
                    </div>
                    <div style={{ display: "flex", width: "100%", marginBottom: "24px", marginTop: "34px" }}>
                        <TextField
                            fullWidth
                            placeholder='نام کاربری'
                            variant='outlined'
                            id='userName'
                            name='userName'
                            inputRef={register({ required: true })}
                        />
                    </div>
                    <div style={{ display: "flex", width: "100%" }}>
                        <TextField
                            fullWidth
                            placeholder='رمز عبور'
                            variant='outlined'
                            id='password'
                            name='password'
                            type={hide ? 'password' : 'text'}
                            inputRef={register({ required: true })}
                            InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton onClick={() => setHide(!hide)}>
                                      <RonadIcons name={hide ? "eyeOff" : "eye"} className={classes.icon}/>
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                        />
                    </div>
                    <Divider style={{ width: '100%', margin: '16px 0  0' }} />
                </DialogContent>
                <DialogActions className={classes.actionsBox}>
                    <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        style={{ textAlign: 'center', marginBottom: '8px' }}
                    >
                        <Grid item xs={12}>
                            <Button
                                style={{ margin: '8px' }}
                                autoFocus
                                onClick={() => setModal("")}
                                variant="outlined"
                                color="primary"
                                size="large"
                                data-cy="cancelRemove"
                            >
                                {'لغو'}
                            </Button>
                            <Button
                                variant="contained"
                                onClick={createToken}
                                size="large"
                                data-cy="confirmRemove"
                                color="primary"
                            >
                                {'ایجاد'}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            <Dialog
                open={modal === "CREATE_EXTERNAL_TOKEN"}
                fullWidth
                onClose={() => setModal("")}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <div
                        style={{
                            position: 'absolute',
                            left: '3px',
                            top: '10px',
                            zIndex: 10,
                        }}
                    >
                        <IconButton aria-label="close" onClick={() => setModal("")}>
                            <RonadIcons name="times" size={0.8}/>
                        </IconButton>
                    </div>
                    <div style={{ display: "flex", width: "100%", marginBottom: "24px", marginTop: "34px" }}>
                        <TextField
                            fullWidth
                            placeholder='توکن(بدون jwt)'
                            variant='outlined'
                            id='token'
                            name='token'
                            inputRef={register({ required: true })}
                        />
                    </div>
                    {shopType !== "DIGIKALA" && <div style={{ display: "flex", width: "100%" }}>
                        <TextField
                            fullWidth
                            placeholder='شناسه فروشگاه'  
                            variant='outlined'
                            id='shopID'
                            name='shopID'
                            inputRef={register({ required: true })}
                        />
                    </div>}
                    <Divider style={{ width: '100%', margin: '16px 0  0' }} />
                </DialogContent>
                <DialogActions className={classes.actionsBox}>
                    <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        style={{ textAlign: 'center', marginBottom: '8px' }}
                    >
                        <Grid item xs={12}>
                            <Button
                                style={{ margin: '8px' }}
                                autoFocus
                                onClick={() => setModal("")}
                                variant="outlined"
                                color="primary"
                                size="large"
                                data-cy="cancelRemove"
                            >
                                {'لغو'}
                            </Button>
                            <Button
                                variant="contained"
                                onClick={createExternalToken}
                                size="large"
                                data-cy="confirmRemove"
                                color="primary"
                            >
                                {'ذخیره'}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            <Dialog
                open={modal === "SHOW_TOKEN"}
                fullWidth
                onClose={() => setModal("")}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <div
                        style={{
                            position: 'absolute',
                            left: '3px',
                            top: '10px',
                            zIndex: 10,
                        }}
                    >
                        <IconButton aria-label="close" onClick={() => setModal("")}>
                            <RonadIcons name="times" size={0.8}/>
                        </IconButton>
                    </div>
                    <div style={{ display: "flex", width: "100%", marginBottom: "24px", marginTop: "34px" }}>
                        <TextField
                            fullWidth
                            placeholder='نام کاربری'
                            variant='outlined'
                            id='userName'
                            name='userName'
                            inputRef={register({ required: true })}
                        />
                    </div>
                    <div style={{ display: "flex", width: "100%" }}>
                        <TextField
                            fullWidth
                            placeholder='رمز عبور'
                            variant='outlined'
                            id='password'
                            name='password'
                            inputRef={register({ required: true })}
                        />
                    </div>
                    <Divider style={{ width: '100%', margin: '16px 0  0' }} />
                </DialogContent>
                <DialogActions className={classes.actionsBox}>
                    <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        style={{ textAlign: 'center', marginBottom: '8px' }}
                    >
                        <Grid item xs={12}>
                            <Button
                                style={{ margin: '8px' }}
                                autoFocus
                                onClick={() => setModal("")}
                                variant="outlined"
                                color="primary"
                                size="large"
                                data-cy="cancelRemove"
                            >
                                {'لغو'}
                            </Button>
                            <Button
                                variant="contained"
                                onClick={showToken}
                                size="large"
                                data-cy="confirmRemove"
                                color="primary"
                            >
                                {'نمایش'}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            <Dialog
                open={modal === "REVOKE_TOKEN"}
                fullWidth
                onClose={() => setModal("")}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <div
                        style={{
                            position: 'absolute',
                            left: '3px',
                            top: '10px',
                            zIndex: 10,
                        }}
                    >
                        <IconButton aria-label="close" onClick={() => setModal("")}>
                            <RonadIcons name="times" size={0.8}/>
                        </IconButton>
                    </div>
                    <h3 style={{textAlign: "center"}}>آیا از حذف توکن خود اطمینان دارید؟</h3>
                    <Divider style={{ width: '100%', margin: '16px 0  0' }} />
                </DialogContent>
                <DialogActions className={classes.actionsBox}>
                    <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        style={{ textAlign: 'center', marginBottom: '8px' }}
                    >
                        <Grid item xs={12}>
                            <Button
                                style={{ margin: '8px' }}
                                autoFocus
                                onClick={() => setModal("")}
                                variant="outlined"
                                color="primary"
                                size="large"
                                data-cy="cancelRemove"
                            >
                                {'لغو'}
                            </Button>
                            <Button
                                variant="contained"
                                onClick={revokeToken}
                                size="large"
                                data-cy="confirmRemove"
                                color="primary"
                            >
                                {'حذف'}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default TokenManagement;
